import { IOrderModel } from './order.models';
import { CLIENT_ORDER_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import {  PagedResult } from 'states/paged-result-model';

export const getOrdersAPI = async (page: number) => {
  return await apiClient.getHttp<PagedResult<IOrderModel>>(
    `${CLIENT_ORDER_API}`,
    {params:{page: page}}
  );
}
export const getOrderAPI = async (id: string) => {
  return await apiClient.getHttp<IOrderModel>(
    `${CLIENT_ORDER_API}/${id}`,
  );
}